import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useAuth} from "features/authentication/hooks/useAuth";
import {ShowingService} from "features/authentication/services/ShowingService/service";
import {IUser} from "features/authentication/models/IUser";
import {User} from "features/authentication/models/User";

export const useAddShowing = () => {

    const queryClient = useQueryClient();
    const {user} = useAuth();

    return useMutation({
        mutationFn: ShowingService.addShowing,
        onMutate: async (showingsParameter) => {
            if(!user) return;

            queryClient.setQueryData(['user'], (oldUser: IUser) => {
                const updatedUser = {
                    ...oldUser,
                    showings: [...(oldUser?.showings || []), {
                        ...showingsParameter,
                        participants: showingsParameter.attendees,
                        created: new Date(),
                    }],
                };

                return new User(updatedUser);
            });
        }
    })
};

export const useRemoveShowing = () => {
    const queryClient = useQueryClient();
    const { user } = useAuth();

    return useMutation({
        mutationFn: ShowingService.deleteShowing,
        onMutate: (showingId: string) => {
            if (!user) return;

            queryClient.setQueryData(['user'], (oldUser: IUser | undefined) => {
                if (!oldUser) return;

                const updatedUser = {
                    ...oldUser,
                    showings: oldUser.showings.filter((x) => x.showingId !== showingId),
                };

                return new User(updatedUser);
            });
        },
    });
};
